module.exports = __webpack_public_path__ + "img/spot-icon.81f19bce.png";